import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Nav } from "@/components/Nav";
import { SmoothScroll } from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ServicePage from "@/pages/ServicePage";
import { PrivacyPolicy, Terms } from "@/pages/Legal";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { ConsentBanner } from "@/components/ConsentBanner";
import { scrollToId } from "@/lib/api";

const ScrollManager = () => {
  const { pathname, state, hash } = useLocation();
  useEffect(() => {
    const target = state?.to || (hash && !hash.includes("session_id") ? hash.slice(1) : null);
    if (target) { const t = setTimeout(() => scrollToId(target), 400); return () => clearTimeout(t); }
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, state, hash]);
  return null;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/payment/success/:orderId" element={<PaymentSuccess />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <FloatingWhatsApp />
      <ConsentBanner />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <AppRouter />
          <Toaster theme="dark" position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
